import { useState, useEffect } from 'react';

export function useIsScreenWidthSmallerThan(thresholdWidth: number) {
	const [isSmaller, setIsSmaller] = useState(() => {
		return window.innerWidth < thresholdWidth;
	});

	useEffect(() => {
		const observer = new ResizeObserver(([entry]) => {
			setIsSmaller(entry.contentRect.width < thresholdWidth);
		});

		observer.observe(document.body);

		return () => observer.disconnect();
	}, [thresholdWidth]);

	return { isSmaller };
}
